import {FC} from "react";
import {AppleSSO, ClasslinkSSO, CleverSSO, FacebookSSO, GoogleSSO, MicrosoftSSO} from "../sso/SsoButtons";
import {WakeletHeader} from "../wakelet-header/WakeletHeader";
import {translate, translateKey} from "../language/translate";
import {Text} from "@wakelet/ui-kit";
import {Link} from "react-router-dom";
import {LoginFormWithResetPassword} from "./LoginFormWithResetPassword";

export const LoginContent: FC = () => {
  return (
    <div className="flex flex-col min-h-[500px]">
      <WakeletHeader message={translate("login.title", "account")}/>
      <div className="flex flex-col items-center">
        <AppleSSO/>
        <GoogleSSO/>
        <MicrosoftSSO/>
        <FacebookSSO/>
        <ClasslinkSSO/>
        <CleverSSO/>
      </div>

      <Text className="text-center">{translateKey("account:or")}</Text>

      <LoginFormWithResetPassword/>
      <SignupText/>
    </div>
  );
};

const SignupText = () => {
  return (
    <Text className="text-center">
      {translate("login.signupLabel", "account")}
      &nbsp;
      <Link to="/sign-up" className="!text-blue-700 !font-bold">{translate("buttons.signup", "common")}</Link>
    </Text>
  );
}


